/*
 *
 * Routes reducer
 *
 */

// import { fromJS } from 'immutable';
import reducerBuilder from 'containers/Rest/reducerBuilder';
import { GPX_UPLOAD_SUCCESS } from 'containers/ImportGpx/constants';
import {
  GET_ENTITY_SUCCESS,
  CHANGE_ENTITY_SUCCESS,
} from 'containers/Rest/constants';
import parseRoute from 'utils/parseRoute';

const restReducer = reducerBuilder('routes');

function routesReducer(state, action) {
  const { type, options, payload } = action;
  if (
    type !== GPX_UPLOAD_SUCCESS &&
    (!options || options.entity !== 'routes')
  ) {
    return restReducer(state, action);
  }
  switch (type) {
    case GET_ENTITY_SUCCESS:
    case CHANGE_ENTITY_SUCCESS:
      if (payload) {
        return state.merge({
          current: { ...parseRoute(payload), loading: false },
        });
      }
      return reduceFromOptions(state, options, action);
    case GPX_UPLOAD_SUCCESS:
      return state.merge({
        current: { ...action.route, loading: false },
      });
    default:
      return restReducer(state, action);
  }
}

export default routesReducer;

function reduceFromOptions(state, options) {
  const { id, body, method } = options;
  const key = id.toString();
  if (method === 'DELETE') {
    const list = state.get('list');
    const filtered = list.filter(item => item !== id);
    return state.remove(key).set('list', filtered);
  }
  const route = state.get(key);
  if (body.isPublic !== undefined) {
    const newRoute = route.set('public', body.isPublic ? 'Y' : 'N');
    return state.set(key, newRoute);
  }

  return state;
}
